<div class="form-title">
	{{label | translate}}
</div>
